@import '../../../../constants/spacing.module.less';

.tags-section-header-content {
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-8;
}

.tags-section-title-and-summary {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.tags-dropdown {
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  min-height: 16px;
  gap: @space-4;
}

.tags-summary-wrapper {
  flex-flow: row wrap;
  gap: @space-4;
}

.tags-summary-tag-text {
  overflow-wrap: anywhere;
}
